import getBlogItems from '@/api/blog/getBlogItems.endpoint';
import Blog from '@/pages/Blog/Blog';
import PageSEO from '@/shared/PageSEO/PageSEO';

export default function BlogPage({ pageProps }) {
  return (
    <>
      <PageSEO title="Spanish Teaching Blog – Ideas & Resources for Educators | Rockalingua" />
      <Blog blogItems={pageProps.blogItems} />
    </>
  );
}

export const getStaticProps = async () => {
  const blogItems = await getBlogItems();
  return { props: { blogItems } };
};
